export const routes =  (prefix = `morgue`) => [
    {
        path: `/${prefix}/discharge-report`,
        name: `${prefix}.discharge-report.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.discharge-report.index`,
                PageDescription: "Morgue: Discharge report",
            },
        },
    },
    {
        path: `/${prefix}/autopsy-report-print`,
        name: `${prefix}.autopsy-report-print.index`,
        component: () => import('./prints/AutopsyReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.discharge-report.index`,
                PageDescription: "Morgue: Discharge report",
            },
        },
    },
    {
        path: `/${prefix}/gatepass-print`,
        name: `${prefix}.gatepass-print.index`,
        component: () => import('./prints/GatePass.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.discharge-report.index`,
                PageDescription: "Morgue: Discharge report",
            },
        },
    },
];
